<template>
  <span>
    <b-dropdown
      id="recipe-filters"
      split-variant="outline-primary"
      variant="primary"
      :text="filterLabel"
      class="recipe-filters-dropdown"
    >
      <b-dropdown-group id="dropdown-group-2" header="Meal Plan" v-if="blok.show_meal_plan_filters">
        <b-dropdown-item-button @click="selectMealPlan(null)" :active="selected_meal_plan==null">All</b-dropdown-item-button>
        <b-dropdown-item-button
          @click="selectMealPlan(plan)"
          :key="index"
          v-for="(plan,index) in meal_plans"
          :active="selected_meal_plan==plan"
        >{{ plan.value }}</b-dropdown-item-button>
      </b-dropdown-group>
      <b-dropdown-group
        id="dropdown-group-1"
        header="Exclude Recipes Including"
        v-if="blok.show_food_groups_filters"
      >
        <b-dropdown-item-button
          @click="selectFoodGroup(group)"
          :active="excluded_groups.indexOf(group)!=-1"
          :key="index"
          v-for="(group,index) in food_groups"
        >{{ group.value }}</b-dropdown-item-button>
      </b-dropdown-group>
    </b-dropdown>
    <!-- recipes -->
  </span>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "recipe-filters",
  data: () => {
      return {
          selected_meal_plan: null,
          excluded_groups: []
      }
  },
  props: {
    blok: Object,
    excludedGroups: Array,
    mealPlan: String,
    useLocal: Boolean
  },
  computed: {
    ...mapState({
      runs: state => state.recipes.shipping_runs,
      food_groups: state => state.recipes.food_groups,
      meal_plans: state => state.recipes.meal_plans
    }),
    filterLabel: function() {
      if(this.$props.useLocal) {
        return this.selected_meal_plan ? this.meal_plans.find( v => v.name ==  this.selected_meal_plan).value : 'All Recipes';
      } else {
        return this.$props.mealPlan ? this.meal_plans.find( v => v.name ==  this.$props.mealPlan).value : "All Recipes";
      }
      return ''
    }
  },
  mounted: function() {
    if(this.$props.excludedGroups)
      this.excluded_groups = this.food_groups.filter( v => (this.$props.excludedGroups.indexOf(v.name) != -1) );
    this.selected_meal_plan = this.meal_plans.find( v => v.name==this.$props.mealPlan );
  },
  methods: {
      selectMealPlan(plan) {
          this.selected_meal_plan = plan;
          this.$emit('selectionChange', { plan: this.selected_meal_plan, groups: this.excluded_groups } );
      },
      selectFoodGroup(group) {
          if(this.excluded_groups.indexOf(group)==-1) {
              this.excluded_groups.push(group)
          } else {
              this.excluded_groups.splice(this.excluded_groups.indexOf(group),1)
          }
          this.$emit('selectionChange', { plan: this.selected_meal_plan, groups: this.excluded_groups } );
      }
  }
};
</script>
